import React, { useRef, useState, useEffect } from 'react';
import * as cls from './recent-blog-posts.module.css';
import { Typography } from '../../../ui/components/typography/typography';
import { Link } from 'react-router-dom';

import { BlogPosts } from '../../../../pages/blog/blog-posts';
const posts = BlogPosts.slice(0, 2);

export const RecentBlogPosts = () => {
  const wrapper = React.useRef(null);
  const sectionRef = useRef(null);
  const [animatedItems, setAnimatedItems] = useState(new Set());

  useEffect(() => {
    const intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const blogPosts = sectionRef.current?.querySelectorAll(
            `.${cls.wrapper} > a`,
          );
          if (blogPosts) {
            blogPosts.forEach((post, index) => {
              setTimeout(() => {
                setAnimatedItems((prev) => new Set(prev).add(index));
              }, index * 400);
            });
          }
        }
      },
      {
        threshold: 0.4,
        rootMargin: '-50px 0px',
      },
    );

    const currentSection = sectionRef.current;
    if (currentSection) {
      intersectionObserver.observe(currentSection);
    }

    const updateHeights = () => {
      if (wrapper.current) {
        const $ps = wrapper.current.querySelectorAll('p');
        $ps[0].style.height = 'auto';
        $ps[1].style.height = 'auto';
        const height1 = $ps[0].clientHeight + 25; // +25 for padding spacing
        const height2 = $ps[1].clientHeight + 25;
        if (height1 !== height2) {
          const height = Math.max(height1, height2);
          $ps[0].style.height = `${height}px`;
          $ps[1].style.height = `${height}px`;
        }
      }
    };

    // Initial update
    updateHeights();

    // Listen for changes using ResizeObserver
    const observer1 = new ResizeObserver(updateHeights);
    const observer2 = new ResizeObserver(updateHeights);

    if (wrapper.current) {
      const $ps = wrapper.current.querySelectorAll('p');
      observer1.observe($ps[0]);
      observer2.observe($ps[1]);
    }

    return () => {
      if (currentSection) {
        intersectionObserver.unobserve(currentSection);
      }
      observer1.disconnect();
      observer2.disconnect();
    };
  }, []);

  return (
    <div ref={sectionRef}>
      <Typography tag="h2">Recent Blog Posts</Typography>

      <div className={cls.wrapper} ref={wrapper}>
        {posts.map((post, index) => (
          <Link
            key={post.link}
            to={post.link}
            className={animatedItems.has(index) ? cls.animated : cls.hidden}
          >
            <img src={post.cover} alt="" />
            <Typography>{post.title}</Typography>
          </Link>
        ))}
      </div>
    </div>
  );
};
